import { undefinedToNull } from '../utilities';

export class FirebaseUserModel {

    name: string;
    lastname: string;
    uid: string;
    nickname: string;
    profile: string;
    imageUrl: string;
    imageLocation: string;
    email: string;
    
    constructor() {
        this.name= '';
        this.lastname= '';
        this.uid= '';
        this.nickname= '';
        this.profile= '';;
        this.imageUrl= null;
        this.imageLocation= '';
        this.email= '';
    }

    toObject() {
        return Object.assign({}, this);
    }

    static objectUserToModel(userData){ //Para convertir el objeto generico a modelo cada vez que recupere de la BBDD
        var user = new FirebaseUserModel();
        user.name=undefinedToNull(userData.name);
        user.lastname=undefinedToNull(userData.lastname);
        user.uid=undefinedToNull(userData.uid);
        user.nickname=undefinedToNull(userData.nickname);
        user.profile=undefinedToNull(userData.profile);
        user.imageUrl=undefinedToNull(userData.imageUrl);
        user.imageLocation=undefinedToNull(userData.imageLocation);
        user.email=undefinedToNull(userData.email);
        return user;
    }
}


